
//
// Input Overlord

inputOverlord = function() {
	var _managedButtons = {};
	var _buttonStates = {};
	var _currentState = "";
	var _inputsBlocked = false;

	this.initialise = function(json) {
		messageBus.post("input:registerButtons", this);

		var states = Object.keys(json.states);
		for (var i = 0; i < states.length; ++i) {
			_buttonStates[states[i]] = json.states[states[i]];
		}
		
		//Default the state to the first one defined
		//N.B. This should always be the Disabled state
		_currentState = states[0];
	};

	this.update = function() {
		if (_inputsBlocked) {
			_inputsBlocked = false;
			return;
		}

		var stateList = _buttonStates[_currentState];
		for (var i = 0; i < stateList.length; ++i) {
			this.enableButton(stateList[i]);
			this.showButton(stateList[i]);
		}
	};

	this.onOrientationChange = function() {
		var buttonNames = Object.keys(_managedButtons);
		for (var i = 0; i < buttonNames.length; ++i) {
			_managedButtons[buttonNames[i]].hideButton();
		}
	};

	this.setState = function(stateName) {
		this.disableAll();
		this.hideAll();

		var newState = _buttonStates[stateName];
		if (_buttonStates[stateName] === undefined) {
			console.log("Invalid input state selected: " + stateName);
			_currentState = "";
		} else {
			_currentState = stateName;
			for (var i = 0; i < newState.length; ++i) {
				this.enableButton(newState[i]);
				this.showButton(newState[i]);
			}
		}
	};

	this.isButtonInCurrentState = function(button){
		var stateList = _buttonStates[_currentState];
		var i;
		for(i = 0; i < stateList.length; ++i)
			if (stateList[i]===button.Props.ID)
				return true;
		return false;
	}

	this.enableAll = function() {
		var states = Object.keys(_managedButtons);
		for (var i = 0; i < states.length; ++i) {
			this.enableButton(states[i]);
		}
	};
	this.disableAll = function() {
		var states = Object.keys(_managedButtons);
		for (var i = 0; i < states.length; ++i) {
			this.disableButton(states[i]);
		}
	};

	this.enableButton = function(name) {
		_managedButtons[name].enableButton();
	};
	this.disableButton = function(name) {
		_managedButtons[name].disableButton();
	};

	this.showAll = function() {
		var states = Object.keys(_managedButtons);
		for (var i = 0; i < states.length; ++i) {
			this.showButton(states[i]);
		}
	};
	this.hideAll = function() {
		var states = Object.keys(_managedButtons);
		for (var i = 0; i < states.length; ++i) {
			this.hideButton(states[i]);
		}
	};

	this.showButton = function(name) {
		_managedButtons[name].showButton();
	};
	this.hideButton = function(name) {
		_managedButtons[name].hideButton();
	};

	this.setText = function(name, text) {
		_managedButtons[name].setText(text);
	};

    this.setTranslatonPhrase = function(name, text) {
        _managedButtons[name].setTranslationPhrase(text);
    };

    this.setTranslationParameters = function(name) {
    	var args = Array.prototype.slice.call(arguments);
    	args.splice(0, 1); //remove first "name" param
        _managedButtons[name].setTranslationParameters(args);
    };

    this.registerButton = function(button) {
		_managedButtons[button.Props.ID] = button;
	};
	this.deregisterButton = function(button) {
		delete _managedButtons[button.Props.ID];
	};

	this.blockButtonPresses = function() { //blocks same-frame presses of multiple buttons - call this in the onPress of your button, see simpleButton in BPstandardOBjectFactory
		_inputsBlocked = true;
	};

	this.areInputsBlocked = function() {
		return _inputsBlocked;
	};

	Reflex.registerEventHandler("orientationChange", this.onOrientationChange.bind(this));
	Reflex.addToUpdate(this.update.bind(this));
};

resourceManager.registerController("inputOverlord", function() {
	return new inputOverlord();
});